import styled from 'styled-components';

export const EmptyWebhooksWrapper = styled.div`
  display: flex;
  border-radius: 12px;
  background-color: ${props => props.theme.colors.background.secondary};
  padding: 54px 28px;
  justify-content: center;
`;
